import type { PosDatabase } from '@core/db/db'
import type { BackupStorage } from './BackupStorage'

/**
 * Web-фолбэк хранилища бэкапов.
 *
 * Снимок БД хранится в отдельном store `backups` той же IndexedDB.
 * Это НЕ защищает от полной очистки IndexedDB ОС — поэтому в проде на
 * мобильном контуре будет подключена нативная Capacitor-реализация.
 * В браузере/десктопе этого достаточно для авто-восстановления после
 * повреждения основных stores.
 *
 * Хранится только последний снимок (старые удаляются), чтобы не раздувать БД.
 */
export class WebBackupStorage implements BackupStorage {
  constructor(private readonly db: PosDatabase) {}

  async save(json: string): Promise<void> {
    await this.db.transaction('rw', this.db.backups, async () => {
      await this.db.backups.clear()
      await this.db.backups.add({
        json,
        size: json.length,
        createdAt: Date.now()
      })
    })
  }

  async load(): Promise<string | null> {
    const latest = await this.db.backups.orderBy('createdAt').last()
    return latest?.json ?? null
  }

  async has(): Promise<boolean> {
    const count = await this.db.backups.count()
    return count > 0
  }
}
